import { StyledPendingFilterTitleSpinner } from "./styles";

/** Spinner for a pending placeholder card's title `icon` slot (renders right after the title). */
export const PendingFilterTitleSpinner = () => (
    <StyledPendingFilterTitleSpinner
        role="progressbar"
        data-automation="filter-panel.pending-filter-spinner"
    />
);
